import { ITable, ITableCell } from "./interfaces";
import { Trow } from "./Trow";

const Thead = (props: { header: ITableCell[] }) => {
  const { header } = props;
  return (
    <thead className="border-b font-medium border-body">
      <Trow data={header} isHead={true} />
    </thead>
  );
};

const Tbody = (props: { rows: ITableCell[][] }) => {
  const { rows } = props;
  return (
    <tbody>
      {rows.map((data, index: number) => (
        <Trow key={index.toString()} data={data} />
      ))}
    </tbody>
  );
};

const Table = (props: ITable) => {
  const { header, rows } = props;

  return (
    <div className={props.className}>
      <div className="overflow-x-scroll">
        <table className={`my-0 text-left border-collapse border border-gray-200 rounded-md border-spacing-0 text-center`} >
          {header && <Thead header={header} />}
          <Tbody rows={rows} />
        </table>
      </div>
    </div>
  );
};

export default Table;
